<div class="partNumberDecoderPage">
  @if (decoding() || exporting()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait</label>
      </div>
    </div>
  }

  <h2>Part Number Decoder</h2>

  <p class="decoderNote">
    For SM and SG that are paired put them together on the same line.
    Example: SMSS09AGD00C3LSSG3009A0BE0011S
  </p>

  <div class="priceBasisRow">
    <label for="priceBasisDate">Price Basis Date:</label>
    <input id="priceBasisDate"
           name="priceBasisDate"
           class="standardTextBox"
           [matDatepicker]="priceBasisPicker"
           [(ngModel)]="priceBasisDate"/>
    <mat-datepicker-toggle [for]="priceBasisPicker"></mat-datepicker-toggle>
    <mat-datepicker #priceBasisPicker></mat-datepicker>
  </div>

  <div class="decoderSelector">
    <label for="prnInput">Part Numbers:</label>
    <textarea id="prnInput"
              name="prnInput"
              class="standardTextBox"
              rows="4"
              cols="35"
              placeholder="Enter one part number per line"
              [(ngModel)]="partNumberInput"></textarea>

    <button type="button"
            class="standardButton"
            [disabled]="!partNumberInput || decoding()"
            (click)="decode()">
      @if (decoding()) { Decoding... } @else { Decode }
    </button>

    <button type="button"
            class="standardButton"
            [disabled]="!results()?.length || exporting()"
            (click)="exportToExcel()">
      @if (exporting()) { Exporting... } @else { Export to Excel }
    </button>
  </div>

  @if (errorMessage()) {
    <div class="errorMessage">{{ errorMessage() }}</div>
  }

  @if (results()?.length) {
    <div class="lineContainer">
      <mat-accordion>
        @for (result of results(); track $index) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><strong>{{ result.partNumberDecodeResult.partNumber }}</strong></mat-panel-title>
              <mat-panel-description>
                @if (result.partNumberDecodeResult.error) {
                  <span class="headerError">{{ result.partNumberDecodeResult.error }}</span>
                } @else {
                  @if (result.configurationData?.bestLeadTime) {
                    <span class="modelInfo">
                      <span class="infoLabel">Best Lead Time:</span>
                      <span>{{ result.configurationData.bestLeadTime.code }}</span>
                    </span>
                  }
                  @if (result.partNumberDecodeResult.guruModelInfo?.modelType) {
                    <span class="modelInfo">
                      <span class="infoLabel">Model:</span>
                      <span>{{ formatModelType(result.partNumberDecodeResult.guruModelInfo.modelType) }}</span>
                    </span>
                  }
                  @if (result.partNumberDecodeResult.guruModelInfo?.priceList) {
                    <span class="modelInfo">
                      <span class="infoLabel">Price List:</span>
                      <span>{{ result.partNumberDecodeResult.guruModelInfo.priceList }}</span>
                    </span>
                  }
                  <span class="spacer"></span>
                  <span class="totalLabel">Total Price:</span>
                  <span class="totalPrice">{{ getTotalPrice(result) | number: '1.2-2' }}</span>
                }
              </mat-panel-description>
            </mat-expansion-panel-header>

            @if (!result.partNumberDecodeResult.error) {
              <div class="expansionPanelContent">
                <div class="decoderTableWrapper">
                  <table class="reportTable">
                    <thead>
                      <tr>
                        <td class="tableCell centeredCell headerCell">Digit</td>
                        <td class="tableCell centeredCell headerCell">Value</td>
                        <td class="tableCell centeredCell headerCell descriptionCell">Description</td>
                      </tr>
                    </thead>
                    <tbody>
                      @for (prnDigit of prnDigits(result); track prnDigit) {
                        <tr>
                          <td class="tableCell">{{ prnDigit }}</td>
                          <td class="tableCell">{{ getSelection(result, prnDigit).userSelectionValue }}</td>
                          <td class="tableCell descriptionCell">{{ getSelection(result, prnDigit).userSelectionDescription }}</td>
                        </tr>
                      } @empty {
                        <tr>
                          <td class="tableCell" colspan="3">No selections found</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>

                <div class="decoderTableWrapper">
                  <table class="reportTable">
                    <thead>
                      <tr>
                        <td class="tableCell centeredCell headerCell">SKU</td>
                        <td class="tableCell centeredCell headerCell descriptionCell">Description</td>
                        <td class="tableCell centeredCell headerCell">Price</td>
                      </tr>
                    </thead>
                    <tbody>
                      @for (sku of result.configurationData?.skus; track sku.name) {
                        <tr>
                          <td class="tableCell">{{ sku.name }}</td>
                          <td class="tableCell descriptionCell">{{ sku.description }}</td>
                          <td class="tableCell rightAligned">{{ sku.price | number: '1.2-2' }}</td>
                        </tr>
                      } @empty {
                        <tr>
                          <td class="tableCell" colspan="3">No SKUs found</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</div>
